import React from 'react'
import PropTypes from 'prop-types'
import { Box, Logo, IconManager, subscriptionsLogoPack, Text, ThemeProvider, Button } from '@deseretbook/react-ui'
import { usePopup } from '@deseretbook/react-utils'
import { SignupModal } from '../subscriptions'

IconManager.register(subscriptionsLogoPack)

/**
 * Additional content for product page.
 *
 * @returns {function} Component
 */
const ProductSidebarContent = ({ user }) => {
  const currentDate = new Date().toISOString().slice(0, 10)
  const isPlusSubscriber = user && !!user.subscriptions
    .filter(({
      subscriptionPlan, awaitingCompletion, serviceableUntil, status,
    }) => !awaitingCompletion && (serviceableUntil >= currentDate || status === 'Active') && subscriptionPlan && subscriptionPlan.type === 'SubscriptionPlan::BookshelfPlus')
    .length
  const [isPlus, setIsPlus] = React.useState(isPlusSubscriber)
  const [hasPlusModal] = React.useState(!isPlus)
  const popup = usePopup()

  return (
    <ThemeProvider>
      <Box paddingTop={1}>
        <React.Fragment>
          {isPlus && (
            <React.Fragment>
              <Box paddingBottom={0.5} justifyContent="center">
                <Box maxWidth={6}>
                  <Logo name="plus" />
                </Box>
              </Box>
              <Text alignment="center" display="block">Thank you for being a valued member of Bookshelf PLUS.</Text>
            </React.Fragment>
          )}
          {!isPlus && (
            <React.Fragment>
              <Box paddingBottom={0.5} justifyContent="center">
                <Box maxWidth={6}>
                  <Logo name="plus" />
                </Box>
              </Box>
              <Text alignment="center" display="block">
                Unlimited Audiobooks & Talks + over 2,500 eBooks
              </Text>
              <Box paddingTop={1} justifyContent="center">
                <Button color="plus" type="button" {...popup.triggerProps}>
                  Sign Up Now
                </Button>
              </Box>
            </React.Fragment>
          )}
          {hasPlusModal && (
            <SignupModal
              popupProps={popup.popupProps}
              user={user}
              onClose={popup.close}
              onSuccess={() => {
                setIsPlus(true)
              }}
              documentUID="product-plus"
              documentType="subscription_signup_v1"
            />
          )}
        </React.Fragment>
      </Box>
    </ThemeProvider>
  )
}

ProductSidebarContent.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    platinum: PropTypes.bool,
  }),
}

ProductSidebarContent.defaultProps = {
  user: {},
}

export default ProductSidebarContent
